const removeBodyMargin = () => {
  const bodyElement = document.querySelector('body');
  if (!bodyElement) return;
  bodyElement.style.margin = '0';
};

const shopifyContentPageCorrection = () => {
  const shopifyStyleElement = document.querySelector('style[data-shopify]');

  if (!shopifyStyleElement) return;

  const mainElement = document.querySelector('#MainContent');

  if (!mainElement) return;

  const pageContainer = mainElement.querySelector('.page-width') as HTMLElement;

  if (pageContainer) {
    pageContainer.style.padding = '0';
    pageContainer.style.maxWidth = 'unset';
  }

  const pageTitle = mainElement.querySelector('.main-page-title');

  if (pageTitle) {
    pageTitle.remove();
  }

  const footerSection = document.querySelector('.shopify-section > .footer') as HTMLElement;

  if (footerSection) {
    footerSection.style.marginTop = '0';
  }
};

export const embeddedAppPageCorrections = () => {
  removeBodyMargin();

  shopifyContentPageCorrection();
};
